import type { AssistantQuery } from '@/types/api';

export const menuKeys = {
  all: ['menus'] as const,
  assistant: (query: AssistantQuery) =>
    [...menuKeys.all, 'assistant', query] as const,
  week: (weekStart: string) => [...menuKeys.all, 'week', weekStart] as const,
  summary: (weekStart: string) =>
    [...menuKeys.all, 'summary', weekStart] as const,
};
